import React from 'react';

import * as css from './Label.css';

export const Label = ({ children }) => <p className={css.Label}>{children}</p>;
